/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Both15Inputs */

const en__field_enum_csjensblank_both15 = /** @type {(inputs: _Field_Enum_Csjensblank_Both15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`both`)
};

const de__field_enum_csjensblank_both15 = /** @type {(inputs: _Field_Enum_Csjensblank_Both15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`beides`)
};

/**
* | output |
* | --- |
* | "both" |
*
* @param {_Field_Enum_Csjensblank_Both15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_both15 = /** @type {((inputs?: _Field_Enum_Csjensblank_Both15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Both15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_both15(inputs)
	return de__field_enum_csjensblank_both15(inputs)
});
export { _field_enum_csjensblank_both15 as "_field_enum_CSJENSBLANK_BOTH" }